import { defineMessages } from 'react-intl';

type MessageKeys =
	| 'createSpaceModalTitle'
	| 'createSpaceNameLabel'
	| 'createSpaceNameHelperMessage'
	| 'createSpaceAboutLabel'
	| 'createSpaceSourcesLabel'
	| 'createSpaceAddSources'
	| 'createSpaceAddSourcesModalTitle'
	| 'createSpaceAddSourcesModalPlaceholder'
	| 'createSpaceRemoveSource'
	| 'createSpaceNameRequired'
	| 'createSpaceEmojiPickerLabel'
	| 'createSpaceCancel'
	| 'createSpaceSubmit'
	| 'createSpaceRequiredFieldsHint';

const message: Record<MessageKeys, { id: string; defaultMessage: string; description?: string }> =
	defineMessages({
		createSpaceModalTitle: {
			id: 'ai-mate.rovo-spaces.create-space-modal.title',
			defaultMessage: 'Create Space',
			description: 'Title of the modal for creating a space from Rovo chat navigation.',
		},
		createSpaceNameLabel: {
			id: 'ai-mate.rovo-spaces.create-space-modal.name-label',
			defaultMessage: 'Name',
			description: 'Label for the required space name field.',
		},
		createSpaceNameHelperMessage: {
			id: 'ai-mate.rovo-spaces.create-space-modal.name-helper',
			defaultMessage: 'Give your Space a short, clear name that explains what it does',
			description: 'Helper text under the space name field in the create space modal.',
		},
		createSpaceAboutLabel: {
			id: 'ai-mate.rovo-spaces.create-space-modal.about-label',
			defaultMessage: 'About',
			description: 'Label for the optional space description field.',
		},
		createSpaceSourcesLabel: {
			id: 'ai-mate.rovo-spaces.create-space-modal.sources-label',
			defaultMessage: 'Sources',
			description: 'Label for the space sources field.',
		},
		createSpaceAddSources: {
			id: 'ai-mate.rovo-spaces.create-space-modal.add-sources',
			defaultMessage: 'Add sources',
			description: 'Button to open the flow for adding more sources to the space.',
		},
		createSpaceAddSourcesModalTitle: {
			id: 'ai-mate.rovo-spaces.create-space-modal.add-sources-modal-title',
			defaultMessage: 'Add sources',
			description:
				'Title of the secondary modal for adding sources (placeholder until designs land).',
		},
		createSpaceAddSourcesModalPlaceholder: {
			id: 'ai-mate.rovo-spaces.create-space-modal.add-sources-placeholder',
			defaultMessage: 'Source picker coming soon.',
			description: 'Placeholder body text in the add-sources modal until the real UI is built.',
		},
		createSpaceRemoveSource: {
			id: 'ai-mate.rovo-spaces.create-space-modal.remove-source',
			defaultMessage: 'Remove {name}',
			description:
				'Accessibility label for the delete control on a source row; {name} is the source title.',
		},
		createSpaceNameRequired: {
			id: 'ai-mate.rovo-spaces.create-space-modal.name-required',
			defaultMessage: 'Enter a name',
			description: 'Validation error when space name is empty.',
		},
		createSpaceEmojiPickerLabel: {
			id: 'ai-mate.rovo-spaces.create-space-modal.emoji-picker',
			defaultMessage: 'Choose emoji',
			description: 'Accessibility label for opening the emoji picker next to the space name field.',
		},
		createSpaceCancel: {
			id: 'ai-mate.rovo-spaces.create-space-modal.cancel',
			defaultMessage: 'Cancel',
			description: 'Button to close the create space modal without saving.',
		},
		createSpaceSubmit: {
			id: 'ai-mate.rovo-spaces.create-space-modal.submit',
			defaultMessage: 'Create',
			description: 'Primary button to submit the create space form.',
		},
		createSpaceRequiredFieldsHint: {
			id: 'ai-mate.rovo-spaces.create-space-modal.required-fields-hint',
			defaultMessage: 'Required fields are marked with an asterisk <asterisk></asterisk>',
			description:
				'Informational text in the create space form header: required fields use an asterisk; the asterisk is rendered via the rich-text placeholder.',
		},
	});

export default message;
